module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author would like to acknowledge the following people for their encouragement and support: D-B Garvin, editor of "), _c('i', [_vm._v("Historical New Hampshire")]), _vm._v(", for her ongoing help in getting Ruth’s story told; Patti Craig, Deb Child and Courtney MacClachlan, for their encouragement, for joining me on field trips and for reading and commenting on the work in progress; Thomas Hardiman, for enduring multiple versions of the book and offering wise commentary; Susan DeGaia, for reading the text and for her kind remarks; Dennis Robinson, for introducing me and my subject to the press and publisher; Andrew Leibs, for his friendship and support through crises of confidence; and friends and family, for their “yes you can” attitude.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 75
// module chunks = 0